import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWhatsNew } from '@innovyze/stylovyze/lib/selectors/whatsNew.selectors';
import { BackLinkContainer, StyledIFrame, StyledWhatsNewDetailIFrame, } from './WhatsNewDetailIFrame.styles';
import { useGetCurrentApp } from '@innovyze/stylovyze/lib/hooks';
import { ProductsIdentifiers } from '@innovyze/stylovyze/lib/types';
import { BackLink } from '@innovyze/stylovyze/lib/components/BackLink';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CloseButton } from '@innovyze/stylovyze/lib/components/CloseButton';
export const WhatsNewDetailIFrame = () => {
    const { iFrameUrl } = useSelector(selectWhatsNew);
    const currentApp = useGetCurrentApp();
    const history = useHistory();
    const currentAppIdentifier = ProductsIdentifiers[currentApp];
    const { t } = useTranslation();
    const src = useMemo(() => {
        const guid = iFrameUrl?.split('/')?.reverse()[0].replace('.htm', '');
        return `https://help.autodesk.com/view/${currentAppIdentifier}/ENU/?guid=${guid}&nof`;
    }, [currentAppIdentifier, iFrameUrl]);
    return (React.createElement(StyledWhatsNewDetailIFrame, null,
        React.createElement(BackLinkContainer, null,
            React.createElement(BackLink, { label: t('Back'), onClick: () => history.goBack() }),
            React.createElement(CloseButton, null)),
        React.createElement(StyledIFrame, { src: src, id: "myIframe", allowFullScreen: true })));
};
